import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e534960"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-inner" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"site-wrapper\" data-v-1e534960><div class=\"brand\" data-v-1e534960><div class=\"siteTitle\" data-v-1e534960><div class=\"animate\" data-v-1e534960><span class=\"spanText showSpan delay200\" data-v-1e534960>TyouMisaka!</span></div></div></div></div>", 1)
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "spanName" }
const _hoisted_5 = { class: "spanDes" }

import { ref, reactive } from "vue";

interface iconImageIf {
  src: string;
}

interface backgroundStyleIf {
  backgroundImage: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ShowHeader',
  setup(__props) {

const iconImage = reactive<iconImageIf>({
  src: require("@/assets/misaka.png"),
});

const backgroundStyle = reactive<backgroundStyleIf>({
  backgroundImage:
    "url(" + require("@/assets/To-Aru-Kagaku-no-Railgun.png") + ")",
});

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "background",
      style: _normalizeStyle(backgroundStyle)
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_card, {
        shadow: "hover",
        class: "site-master"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "site-master-avater",
            src: iconImage.src,
            alt: "TyouMisaka"
          }, null, 8, _hoisted_3),
          _createElementVNode("h2", null, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("menus.home.hitokoto.idea")), 1),
            _createElementVNode("span", _hoisted_5, "  " + _toDisplayString(_ctx.$t("menus.home.hitokoto.result")), 1)
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})